import './resellerinventoryscreen.styles.scss';
import { useSelector } from 'react-redux';
import Sidebar from '../../../components/sidebar/sidebar.component';
import HeaderComponent from '../../../components/header-component/header.component';
import HeadingPrimary from '../../../components/typography/headings/heading-primary/heading-primary.component';
import { useContext, useState, useEffect, useCallback } from 'react';
import { SimContext } from '../../../api/SimContext';
import HeadingSecondary from '../../../components/typography/headings/heading-secondary/heading-secondary.component';
import { IoMdSearch } from 'react-icons/io';
import Dropdown from '../../../components/dropdown/dropdown.component';
import { IoReloadCircleSharp } from "react-icons/io5";
import { MdArrowBack } from 'react-icons/md';
import { MdArrowForward } from 'react-icons/md';
import { RiFileDownloadFill } from 'react-icons/ri';


const ResellerInventoryScreen = ({ setInventoryCount }) => {
  const { allSims, offers, sellSim, reloadKey, setReloadKey, pageCount, setPageCount, fetchSimCardDataWithQuery, downloadCSV, addTag, fetchSimViaId } = useContext(SimContext);
  const [isSpinning, setIsSpinning] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredInventorySims, setFilteredInventorySims] = useState([]);
  const [selections, setSelections] = useState({});
  const { user } = useSelector((state) => state.user);
  const [errors, setErrors] = useState({});

  const productOptions = offers.map(offer => ({
    'name': offer.name,
    'id': offer.id
  }));

  const durationOptions = [
    { name: "30 days", dayNumber: 30 }, 
    { name: "90 days", dayNumber: 90 },
    { name: "180 days", dayNumber: 180 }
  ];

  const handleReload = () => {
    setIsSpinning(true);
    setTimeout(() => {
      setReloadKey(reloadKey + 1);
      setIsSpinning(false);
    }, 1200); 
  };

  const handleSelect = (simId, option, type) => {
    setSelections(prev => ({
      ...prev,
      [simId]: {
        ...prev[simId],
        [type]: option,
        sold: prev[simId]?.sold || false
      }
    }));

    setErrors(prev => ({
      ...prev,
      [simId]: {
          ...prev[simId],
          [type]: undefined // Clears the error for 'product' or 'duration'
      }
  }));
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    now.setMilliseconds(0);
    return now.toISOString().slice(0, -5) + 'Z'; 
  };

  const handleSell = async (simId) => {
    const simSelections = selections[simId];
    let error = {}
   
    if (!simSelections?.product) {
      error.product = "Please select a product option.";
      setErrors(prev => ({ ...prev, [simId]: error }));
      return
  }
  if (!simSelections?.duration) {
      error.duration = "Please select a duration.";
      setErrors(prev => ({ ...prev, [simId]: error }));
      return
  }
    if (!simSelections.sold) {
      const simCard = await fetchSimViaId(simId)
      const currentIndexes = simCard.tags
        .map(tag => {
          const match = tag.match(/index=(\d+)/);
          return match ? parseInt(match[1], 10) : 0;
        })
        .filter(index => !isNaN(index));

      const highestIndex = currentIndexes.length > 0 ? Math.max(...currentIndexes) : 0;
      const newIndex = highestIndex + 1;
      const activatedDate = getCurrentDateTime() 
      const infoTags = [
        `reseller=${user[3]}#index=${newIndex}`,
        `duration=${simSelections.duration.dayNumber}#index=${newIndex}`,
        `offer=${simSelections.product.name}#index=${newIndex}`,
        `activatedDate=${activatedDate}#index=${newIndex}`
      ];
      sellSim(simId, simSelections.product.id, simSelections.duration.dayNumber, infoTags);
      setSelections(prev => ({
        ...prev,
        [simId]: {
          ...prev[simId],
          sold: true
        }
      }));
      setTimeout(() => {
        setFilteredInventorySims(currentSims => currentSims.filter(s => s.id !== simId));
      }, 700);
    } else {
      console.log("SIM is already sold.");
    }
  };


  const debounce = (func, wait) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  };

// Search and filter functionality
  const fetchData = useCallback(
    debounce(async (searchTerm) => {
      if (searchTerm.length > 0) {
        const foundSims = await fetchSimCardDataWithQuery('INACTIVE', searchTerm);
        setFilteredInventorySims(foundSims);
      } else {
        const filtered = allSims.filter(sim => 
          sim.status === "INACTIVE" && 
          (!sim.tags || !sim.tags.some(tag => tag.includes("Sold")))
        );
        setFilteredInventorySims(filtered);
      }
    }, 300), 
    [allSims, fetchSimCardDataWithQuery]
  );

  useEffect(() => {
    fetchData(searchTerm);
  }, [searchTerm, fetchData]);

  useEffect(() => {
    setInventoryCount(filteredInventorySims.length);
  }, [filteredInventorySims.length, setInventoryCount]);

  // Page flipper logic
  const handleBackClick = () => {
    if (pageCount > 0) {
      setPageCount(prevCount => prevCount - 1);
    }
  };

  const handleForwardClick = () => {
    setPageCount(prevCount => prevCount + 1);
  };

    return (
    <div className='content-container-component'>
      <div className="messages-container">
        <div className='table-heading-container'>
          <IoReloadCircleSharp size={28} color='black' onClick={handleReload} style={{ cursor: 'pointer' }} className={`reload-div ${isSpinning ? 'spin-animation' : ''}`} />
          {/* <RiFileDownloadFill  onClick={() => downloadCSV('INACTIVE')} size={28} color='black' style={{ cursor: 'pointer' }}/> */}
          {/* <div className='page-flip-container'>
            <MdArrowBack size={26} color='black' onClick={handleBackClick} />
            <div className='page-flipper-text'>{pageCount + 1}</div>
            <MdArrowForward size={26} color='black' onClick={handleForwardClick} />
          </div> */}
          <div className="search-container">
            <IoMdSearch size={28} color='#646272' />
            <input
              type="text"
              className="search-input"
              placeholder="Search SIM"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        <div className='table-scroll-container'>
          <div className='panel-small'>
            <div className='panel-heading'>
              <div className='inner-panel-heading'>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`MSISDN - SIM EID`} mode={'light'} />
                </div>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`Product`} mode={'light'} />
                </div>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`Duration`} mode={'light'} />
                </div>
                <div className='header-container-reseller'>
                  <HeadingSecondary text={`Action`} mode={'light'} />
                </div>
              </div>
            </div>
            <div className='panel-content-container'>
              <div className='sim-heading-container'>
                <div className='sortby-container'>
                </div>
              </div>
              <div className='scroll-container'>
                {filteredInventorySims.map(sim => (
                  <div key={sim.eid} className="reseller-block-table">
                    <div className="sim-info-reseller">
                      <div className="sim-text-bold">{sim.msisdn}<br/>
                      {searchTerm ? sim.eid32 : sim.eid} 
                      </div>
                    </div>
                    <div className='dropdown-container'>
                      <Dropdown label="Choose an option" options={productOptions} onSelect={(option) => handleSelect(sim.id, option, 'product')} />
                      {errors[sim.id] && errors[sim.id].product && <div className="error-text">{errors[sim.id].product}</div>}
                    </div>
                    <div className='dropdown-container'>
                      <Dropdown label="Choose an option" options={durationOptions} onSelect={(option) => handleSelect(sim.id, option, 'duration')} />
                      {errors[sim.id] && errors[sim.id].duration && <div className="error-text">{errors[sim.id].duration}</div>}
                    </div>
                    <div className='sell-button-container' onClick={() => handleSell(sim.id)}>
                      <div className={`${selections[sim.id]?.sold ? 'loader' : 'sell-block'}`}>
                        <div className='sim-text'>{selections[sim.id]?.sold ? '' : 'Sell'}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResellerInventoryScreen;
